import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CategorizacionTramiteDto, ICategorizacionTramite } from '../../shared/interfaces/database/configuracion';


@Injectable({
  providedIn: 'root'
})
export class CategorizacionTramiteService {
  private readonly baseUrl = `${environment.apiUrl}/api/categorizacion-tramite`;

  constructor(private http: HttpClient) { }

  getCategorizaciones(): Observable<ICategorizacionTramite[]> {
    return this.http.get<ICategorizacionTramite[]>(`${this.baseUrl}`);
  }

  createCategorizacionTramite(request: CategorizacionTramiteDto): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  updateCategorizacionTramite(id:number, request: CategorizacionTramiteDto): Observable<string> {
    return this.http.put(`${this.baseUrl}/${id}`, request, { responseType: 'text' });
  }

  deleteCategorizacionTramite(id: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${id}`, { responseType: 'text' });
  }
}
